import PropTypes from "prop-types";
import {
  Briefcase,
  Building2,
  DollarSign,
  TrendingUp,
} from "lucide-react";
import { Card, CardContent } from "components/ui/card";
import { formatMoney } from "lib/investmentListHelpers";
import { cn } from "lib/utils";

function StatCard({ label, value, subtitle, icon: Icon, iconWrapClassName }) {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground">{label}</p>
            <p className="text-2xl font-bold">{value}</p>
            {subtitle ? (
              <p className="text-xs text-muted-foreground">{subtitle}</p>
            ) : null}
          </div>
          <div
            className={cn(
              "flex h-12 w-12 shrink-0 items-center justify-center rounded-full",
              iconWrapClassName
            )}
          >
            <Icon className="h-6 w-6" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

StatCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.elementType.isRequired,
  iconWrapClassName: PropTypes.string.isRequired,
};

export function PortfolioStatsCards({ loading, stats, currency, className }) {
  const display = (value) => (loading ? "—" : value);
  const displayCurrency = currency ?? "USD";

  return (
    <div
      className={cn(
        "grid gap-4 sm:grid-cols-2 lg:grid-cols-4",
        className
      )}
    >
      <StatCard
        label="Total Invested"
        value={display(formatMoney(stats.totalInvested, displayCurrency))}
        icon={DollarSign}
        iconWrapClassName="bg-primary/10 text-primary"
      />
      <StatCard
        label="Total Share"
        value={display(stats.portfolioValue)}
        icon={TrendingUp}
        iconWrapClassName="bg-accent/10 text-accent"
      />
      <StatCard
        label="Total Projects"
        value={display(stats.totalProjects)}
        subtitle="Live offerings"
        icon={Building2}
        iconWrapClassName="bg-primary/10 text-primary"
      />
      <StatCard
        label="Investments"
        value={display(stats.activeInvestments)}
        subtitle="Active positions"
        icon={Briefcase}
        iconWrapClassName="bg-primary/10 text-primary"
      />
    </div>
  );
}

PortfolioStatsCards.propTypes = {
  loading: PropTypes.bool.isRequired,
  currency: PropTypes.string,
  stats: PropTypes.shape({
    totalInvested: PropTypes.number.isRequired,
    portfolioValue: PropTypes.number.isRequired,
    totalProjects: PropTypes.number.isRequired,
    activeInvestments: PropTypes.number.isRequired,
  }).isRequired,
  className: PropTypes.string,
};
